<footer class="bg-shl-navy pt-20 pb-10 text-white">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="grid grid-cols-1 gap-12 text-center md:grid-cols-4 md:text-left">
      <div class="col-span-1 md:col-span-1">
        <div class="mb-2 flex w-full items-center justify-center rounded bg-white/90 py-2 ps-3 pe-4 md:justify-start">
          <img
            src="assets/brand/title.svg"
            [attr.alt]="'navbar.logo_alt' | translate"
            title="{{ 'navbar.logo_alt' | translate }}"
            class="h-16 w-full object-contain"
            loading="lazy"
            decoding="async"
          />
        </div>
        <p class="text-sm text-gray-400 leading-relaxed">
          {{ 'footer.description' | translate }}
        </p>
        <div class="mt-6 flex gap-4 justify-center md:justify-start">
          <a class="text-gray-400 hover:text-white" href="#">
            <mat-icon fontSet="material-symbols-outlined">public</mat-icon>
          </a>
          <a class="text-gray-400 hover:text-white" href="#">
            <mat-icon fontSet="material-symbols-outlined">mail</mat-icon>
          </a>
          <a class="text-gray-400 hover:text-white" href="#">
            <mat-icon fontSet="material-symbols-outlined">call</mat-icon>
          </a>
        </div>
      </div>
      <div>
        <h3 class="mb-6 text-sm font-bold uppercase tracking-wider text-gray-300">
          {{ 'footer.services_title' | translate }}
        </h3>
        <ul class="space-y-3 text-sm text-gray-400">
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.services.freight_forwarding' | translate }}
            </a>
          </li>
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.services.customs_clearance' | translate }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="mb-6 text-sm font-bold uppercase tracking-wider text-gray-300">
          {{ 'footer.company_title' | translate }}
        </h3>
        <ul class="space-y-3 text-sm text-gray-400">
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.company.about_us' | translate }}
            </a>
          </li>
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.company.our_network' | translate }}
            </a>
          </li>
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.company.careers' | translate }}
            </a>
          </li>
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.company.news_insights' | translate }}
            </a>
          </li>
          <li>
            <a class="hover:text-shl-sky transition-colors" href="#">
              {{ 'footer.company.contact' | translate }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="mb-6 text-sm font-bold uppercase tracking-wider text-gray-300">
          {{ 'footer.contact_title' | translate }}
        </h3>
        <ul class="space-y-4 text-sm text-gray-400">
          <li class="flex gap-3 justify-center md:justify-start md:items-start">
            <mat-icon fontSet="material-symbols-outlined" class="text-shl-sky">location_on</mat-icon>
            <span class="text-center md:text-left">
              {{ 'footer.contact.tunisia_line1' | translate }}<br />
              {{ 'footer.contact.tunisia_line2' | translate }}
            </span>
          </li>
          <li class="flex gap-3 justify-center md:justify-start md:items-start">
            <mat-icon fontSet="material-symbols-outlined" class="text-shl-sky">phone</mat-icon>
            <span class="text-center md:text-left">{{ 'footer.contact.phone' | translate }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="mt-16 border-t border-white/10 pt-8 text-center text-xs text-gray-500">
      <p>{{ 'footer.copyright' | translate }}</p>
    </div>
  </div>
</footer>
